/* cvn-drawer-nav-close.js — lifted verbatim out of snippets/cvn-drawer-nav-close.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was. */
  (function () {
    if (window.cvnDrawerNavCloseInit) return;
    window.cvnDrawerNavCloseInit = true;

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target || !event.target.closest) return;

        var link = event.target.closest('#CartDrawer a[href]');
        if (!link) return;

        // not a navigation: new tab, download, or an explicit opt-out
        if (link.target && link.target !== '_self') return;
        if (link.hasAttribute('download')) return;
        if (link.hasAttribute('data-cvn-keep-drawer')) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (event.button && event.button !== 0) return;

        // a bare "#" or a javascript: href goes nowhere, so there is nothing
        // to close the drawer for
        var href = link.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#' || href.toLowerCase().indexOf('javascript:') === 0) return;

        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        // Two ways in. The EMPTY drawer closes on any link, because every link
        // on that screen exists to send the shopper elsewhere. A NON-empty
        // drawer closes only for a link that opted in with
        // `data-cvn-close-drawer` — the bag icon that opens the full cart page
        // is one; a product link on a cart line is deliberately NOT, since a
        // shopper checking a photo may well come straight back.
        var optedIn = link.hasAttribute('data-cvn-close-drawer');
        if (!optedIn && !drawer.classList.contains('is-empty')) return;

        // Dawn owns the teardown (classes, body scroll lock, focus return);
        // the fallback only exists for a drawer whose custom element has not
        // upgraded yet, which is possible on a very early click
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.classList.remove('active', 'animate');
          document.body.classList.remove('overflow-hidden');
        }
      },
      true
    );
  })();
